export interface EmailVariable {
  key: string
  label: string
  description: string
  example: string
}

export function getVariableOptions(variables: EmailVariable[]): { code: string; label: string }[] {
  return variables.map((v) => ({
    code: v.key.replace(/\{\{|\}\}/g, '').trim(),
    label: v.label
  }))
}

export const emailVariables: EmailVariable[] = [
  {
    key: '{{first_name}}',
    label: 'Prénom',
    description: 'Prénom du client',
    example: 'Jean'
  },
  {
    key: '{{last_name}}',
    label: 'Nom',
    description: 'Nom du client',
    example: 'Dupont'
  },
  {
    key: '{{points}}',
    label: 'Points',
    description: 'Points de fidélité',
    example: '150'
  }
]
